module.exports = "/_next/static/images/Seasonal-pattern-spring-tnm-b8122ec9410d40de6f931cf2cc293ba3.png";